import { useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';

const CardCredentialDeclinedScreen = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('cardManagement', {
    keyPrefix: 'credentialChallenge.declined',
  });

  return (
    <ErrorScreen
      screenType={ErrorScreenType.Warning}
      messageHeadline={translatedText('title')}
      messageBody={translatedText('message')}
      primaryButton={{
        title: translatedText('doneButton'),
        onPress: () => router.back(),
      }}
    />
  );
};

export default CardCredentialDeclinedScreen;
